module.exports = {
      id: "share-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#share",
      toString: function () {
        return this.url;
      }
    }